import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import { Box, Button, TextField, Grid, Typography } from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import Divider from "@mui/material/Divider";
import { Link, useNavigate, useParams } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";

function AddProduct() {
  const navigate = useNavigate();
  const [productInput, setProduct] = useState({
    name: "",
    error_list: [],
  });
  const handleInput = (e) => {
    e.persist();
    setProduct({ ...productInput, [e.target.name]: e.target.value });
  };

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  const submitProduct = (e) => {
    e.preventDefault();
    let userId = localStorage.getItem("auth_id");
    console.log(userId);

    const data = {
      name: productInput.name,
      user_id:userId,
    };

    axios.post(`/api/add-product`,data).then(res =>{
      if(res.data.status === 200){
        swal("Success",res.data.message,"success");
        document.getElementById('CATEGORY_FORM').reset();
        navigate('/certificates/product');
      }
      else if(res.data.status === 400){
        setProduct({...productInput,error_list:res.data.errors});
      }
    });
  };

  return (
    <div>
      <Navbar />
      <div className="card px-8 m-5">
        <div className="card-header">
          <Grid container spacing={70}>
            <Grid item xs={8}>
              <h4>Add Category</h4>
            </Grid>
            <Grid item xs={4}>
              <ThemeProvider theme={theme}>
                <Button
                  component={Link}
                  to="/certificates/product"
                  variant="contained"
                  color="apple"
                >
                  Back
                </Button>
              </ThemeProvider>
            </Grid>
          </Grid>
        </div>
        <form onSubmit={submitProduct} id="CATEGORY_FORM">
          <Grid container spacing={5}>
            <Grid item xs={15}>
              <Box
                paddingTop={1}
                borderRadius={1}
                paddingLeft={40}
                paddingRight={40}
              >
                <TextField
                  fullWidth
                  name="name"
                  id="outlined-basic"
                  onChange={handleInput}
                  value={productInput.name}
                  margin="normal"
                  label="Category Name"
                  variant="outlined"
                />
                <span style={{ color: "red" }}>
                  {productInput.error_list.name}
                </span>
              </Box>
            </Grid>
          </Grid>
          <ThemeProvider theme={theme}>
            <Box
              marginTop={1}
              display="flex"
              padding={3}
              borderRadius={5}
              alignItems="center"
              justifyContent={"center"}
            >
              <Button
                style={{
                  maxWidth: "200px",
                  maxHeight: "100px",
                  minWidth: "50px",
                  minHeight: "30px",
                }}
                color="apple"
                type="submit"
                variant="contained"
              >
                Add
              </Button>
            </Box>
          </ThemeProvider>
        </form>
      </div>
    </div>
  );
}

export default AddProduct;
